import React from "react";
import { Modal, Button } from "react-bootstrap";
import { navigate } from "@reach/router";
import usePropuestaActions from "../hooks/use_propuesta_actions";

const AdminModal = ({
  onHide,
  show,
  isBorrar,
  setShow,
  propuesta,
}) => {
  const { doDeletePropuesta, doAcceptPropuesta } = usePropuestaActions();

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isBorrar
            ? "Borrar Propuesta"
            : propuesta.articulo
            ? "Aplicar Edición"
            : "Publicar Artículo"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isBorrar
          ? "¿Está seguro de que desea rechazar y borrar esta propuesta? Este proceso no se puede deshacer."
          : propuesta.articulo
          ? '¿Está seguro de que desea aplicar esta edición, reemplazando el contenido del artículo "' +
            (propuesta.titulo || "Sin Título") +
            '" actual?'
          : `¿Está seguro de que sea publicar el artículo "${
              propuesta.titulo || "Sin Título"
            }" según el contenido propuesto?`}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          No
        </Button>
        <Button
          variant={isBorrar ? "danger" : "success"}
          onClick={
            isBorrar
              ? async () => {
                  const resJson = await doDeletePropuesta(propuesta._id);
                  if (resJson) {
                    alert("¡Se ha rechazado la propuesta exitosamente!");
                    setShow(false);
                    navigate("/admin");
                  } else {
                    alert(
                      "¡Hubo un error inesperado al intentar borrar la propuesta! Intente de nuevo más tarde."
                    );
                  }
                }
              : async () => {
                  const resJson = await doAcceptPropuesta(propuesta._id);
                  if (resJson) {
                    alert("¡La propuesta ha sido publicada!");
                    setShow(false);
                    navigate("/admin");
                  } else {
                    alert(
                      "¡Hubo un error inesperado al intentar borrar la propuesta! Intente de nuevo más tarde."
                    );
                  }
                }
          }
        >
          {isBorrar ? "Sí, Borrar" : "Sí, Publicar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminModal